import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions, { thunks } from '../../redux/modules/offers';


import { PageWrapper, Loader, Alert, ErrorText } from '../../components';
import OfferModal from './components/offerModal';
import { isEqual } from "lodash";



class Offers extends React.Component {
    state = {
        disableSave: true,
        numImages: 0,
        offerToDelete: null,
        listData: [],
        offerToEdit: {},
        offerType: 1
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(thunks.getOffer());
        this.setTableView(1);

    }
    componentDidUpdate(prevProps) {
        const { list } = this.props;
        if (!isEqual(list, prevProps.list)) {
            this.setTableView(this.state.offerType);
        }
    }


    setTableView = (tab) => {
        var { list } = this.props;

        if (tab === 1) {
            this.setState({ offerType: 1, listData: list.filter(item => item.offerType === 1) })
        }
        if (tab === 2) {
            this.setState({ offerType: 2, listData: list.filter(item => item.offerType === 2) })
        }
        if (tab === 3) {
            this.setState({ offerType: 3, listData: list.filter(item => item.offerType === 3) })
        }
        if (tab === 4) {
            this.setState({ offerType: 4, listData: list.filter(item => item.offerType === 4) })
        }
    }

    onAddOfferModal = () => {
        this.setState({ offerToEdit: {} })
        this.openOfferModal()
    }

    openOfferModal = () => {
        const { updateProperty } = this.props;
        updateProperty('showOfferModal', true);
    }

    onHideModal = () => {
        const { updateProperty, dispatch } = this.props;
        dispatch(thunks.clearOfferProducts());
        updateProperty('showOfferModal', false);
    }

    deleteOffer = (offer) => {
        this.setState({ offerToDelete: offer })
    }

    handleDeleteOffer = () => {
        const { dispatch } = this.props;
        const { offerToDelete } = this.state;
        dispatch(thunks.deleteOffer(offerToDelete.id));
        this.setState({ offerToDelete: null })

    }

    onAddProducts = () => {
        const { dispatch } = this.props;
        dispatch(thunks.addOfferProducts());
    }

    onAddOffer = body => {
        body.discountBy == 1 ? body.percentage = 0 : body.amount = 0;
        body.unitType == 1 ? body.pieces = 0 : body.squareFeet = 0;
        const { dispatch } = this.props;
        dispatch(thunks.addOffer(body));
    }

    editOffer = offer => {
        const { updateProperty, dispatch } = this.props;
        updateProperty('offerId', offer.id);
        dispatch(thunks.getOfferProducts());
        this.setState({ offerToEdit: offer,offerProducts:this.props.offerProducts }, () => {
            this.openOfferModal();

        })
    }

    onEditOffer = body => {
        body.discountBy == 1 ? body.percentage = 0 : body.amount = 0;
        body.unitType == 1 ? body.pieces = 0 : body.squareFeet = 0;
        const { dispatch } = this.props;
        dispatch(thunks.editOffer(body));
    }

    render() {
        const {
            loading,
            error,
            updateProperty,
            showOfferModal,
            offerProducts

        } = this.props;
        const { offerToDelete, listData, offerToEdit, offerType } = this.state;

        return (
            <PageWrapper title="Product Offers">
                <Loader show={loading} />
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Product Offers"
                    message={error}
                />

                <div className="card m-2">
                    <h5 className="card-header">Product Offers</h5>
                    <div className="card-body">
                        <h5 className="card-title">
                            <button type="button" className={`mr-2 btn btn-pink  ${offerType === 1 ? 'active-btn' : ''}`} onClick={() => this.setTableView(1)} >Add Multiple Offer</button>
                            <button type="button" className={`mr-2 btn btn-pink  ${offerType === 2 ? 'active-btn' : ''}`} onClick={() => this.setTableView(2)} >Non Tile Product Offer</button>
                            <button type="button" className={`mr-2 btn btn-pink  ${offerType === 3 ? 'active-btn' : ''}`} onClick={() => this.setTableView(3)} >Tile Product Offer</button>
                            <button type="button" className={`btn btn-pink  ${offerType === 4 ? 'active-btn' : ''}`} onClick={() => this.setTableView(4)} >Amount Based Offer</button>
                        </h5>

                        <button type="button" className="pull-right mb-2 btn btn-primary" onClick={this.onAddOfferModal}>Add</button>
                        <table className="table table-bordered pt-2">
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    {offerType != 4 && <>
                                        <th scope="col">Offer Description</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">Image Description</th>
                                    </>}
                                    {offerType == 3 && <>
                                        <th scope="col">Pieces</th>
                                        <th scope="col">Square Feet</th>
                                    </>}
                                    {offerType == 4 && <th scope="col">Max Amount</th>}
                                    {offerType == 2 && <th scope="col">Quantity</th>}
                                    <th scope="col">Amount</th>
                                    <th scope="col">Percentage</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            {listData.length ? (
                                listData.map(offer => (
                                    <tr key={offer.id}>
                                        <th>{offer.id}</th>
                                        {offerType != 4 && <>
                                            <td>{offer.offerDescription||''}</td>
                                            <td>
                                                <td>
                                                    {offer.imageId ? <img src={offer.imageId} alt="image" width="80px" /> : '-'}
                                                </td>
                                            </td>
                                            <td>{offer.imageDescription ||''}</td>
                                        </>}
                                        {offerType == 3 && <><td>{offer.pieces}</td>
                                            <td>{offer.squareFeet}</td></>}
                                        {offerType == 4 && <td>{offer.maximumAmount}</td>}
                                        {offerType == 2 && <td>{offer.quantity}</td>}
                                        <td>{offer.amount}</td>
                                        <td>{offer.percentage}</td>
                                        <td><button title="Delete Agent" className="btn btn-xs btn-danger" onClick={() => this.deleteOffer(offer)}>
                                            <i className="fa fa-trash" />
                                        </button>
                                            <button title="View User" className="btn btn-xs btn-info ml-2" onClick={() => this.editOffer(offer)}>
                                                <i className="fa fa-pencil" />
                                            </button> </td>
                                    </tr>)))
                                : (
                                    <tr>
                                        <td colSpan="8" className="text-center">No Records Found</td>
                                    </tr>
                                )}
                        </table>
                    </div>
                </div>
                {showOfferModal && <OfferModal
                    show={showOfferModal}
                    onHide={this.onHideModal}
                    data={offerToEdit}
                    addOffer={this.onAddOffer}
                    editOffer={this.onEditOffer}
                    offerType={offerType}
                    offerProducts={offerProducts}
                    onAddProducts={this.onAddProducts}
                />
                }
                <Alert
                    show={!!offerToDelete}
                    onHide={() => this.setState({ offerToDelete: null })}
                    title="Delete Offer"
                    message={`Are you sure you want to delete Offer ID: ${(offerToDelete || {}).id}?`}
                    onSubmit={this.handleDeleteOffer}
                />
            </PageWrapper>

        )
    }
}


const mapStateToProps = ({
    offers: {
        loading,
        error,
        list,
        showOfferModal,
        offerProducts
    },
}) => ({
    loading,
    error,
    list,
    showOfferModal,
    offerProducts
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Offers)